import FormSelect from './FormSelect'
import { mapGetters } from 'vuex'
import {
  getCampuses
} from '@/api'
export default {
  extends: FormSelect,
  props: {
    config: {
      type: Object,
      default: () => ({}),
    },
  },
  inject: {
    fetchOptionsOnMount: {
      type: Boolean,
      default: () => (false),
    },
    excludeOptions: {
      type: Array,
      default: () => ([]),
    },
    setAvailableOptions: {
      type: Function,
      default: () => (null),
    },
  },
  data () {
    return {
      isOpen: false,
      isLoading: false,
      options: [],
      optionsLoaded: false,
    }
  },
  mounted () {
    if (this.fetchOptionsOnMount) { this.fetchCampuses() }
  },
  computed: {
    ...mapGetters([ 'school' ]),
    mergedConfig () {
      return {
        searchable: true,
        options: [],
        ...this.config,
        // the formCampusSelect field is ONLY single select
        // and if you are looking for the multiselect option,
        // you should use the formCampusesSelect input
        multiple: false,

      }
    },
    normalizedOptions () {
      // UI should display the campus description if that field is set
      // NOTE: we only want to sort the options loaded in from the BE
      // Any user defined options should retain the sort order in which they were entered
      const options = Object.values(this.options).map(el => el.description || el.campus).sort()

      let optionsWithHardCodedValues = options.filter(Boolean).concat(this.mergedConfig.options || [])

      if (this.excludeOptions?.value) {
        optionsWithHardCodedValues = optionsWithHardCodedValues.filter(option => !this.excludeOptions.value.includes(option))
      }

      // If config.optionsFromAction is non-blank array then some action is triggered
      // and options are filtered based on actions
      const optionsFromAction = this.mergedConfig.optionsFromAction

      if (optionsFromAction && optionsFromAction.length > 0) {
        optionsWithHardCodedValues = optionsWithHardCodedValues.filter(option => optionsFromAction.includes(option))
      }

      // ensuring options are unique and sorting the resulting array
      return [ ...new Set(optionsWithHardCodedValues) ]
    },
  },
  watch: {
    isOpen: {
      async handler (val) {
        if (val && !this.optionsLoaded) {
          this.fetchCampuses()
        }
      },
    },
    normalizedOptions: {
      handler (options) {
        if (!this.setAvailableOptions || typeof this.setAvailableOptions !== 'function') { return }

        this.setAvailableOptions(options)
      },
    },
  },
  methods: {
    async fetchCampuses () {
      this.isLoading = true
      const { data = {} } = await getCampuses({ school: this.school }) || {}
      this.options = data
      this.optionsLoaded = true
      this.isLoading = false
    },
  },
}
